import Svg from '@app/components/svg';

const DocumentsWithStars = Svg(
  <>
    <g clip-path="url(#clip0_807_2058)">
      <g filter="url(#filter0_d_807_2058)">
        <path
          d="M140.997 70.8521H45.7619C44.1202 70.8521 42.7894 72.1817 42.7894 73.822V201.359C42.7894 202.999 44.1202 204.329 45.7619 204.329H140.997C142.639 204.329 143.97 202.999 143.97 201.359V73.822C143.97 72.1817 142.639 70.8521 140.997 70.8521Z"
          fill="white"
        />
        <path
          d="M131.184 118.713H57.3231C56.3816 118.713 55.6184 119.475 55.6184 120.416V144.058C55.6184 144.999 56.3816 145.762 57.3231 145.762H131.184C132.126 145.762 132.889 144.999 132.889 144.058V120.416C132.889 119.475 132.126 118.713 131.184 118.713Z"
          fill="white"
        />
        <path
          d="M81.7386 130.838H59.0017V133.691H81.7386V130.838Z"
          fill="#D3E8F4"
        />
        <path
          d="M89.4704 121.773H59.0017V124.626H89.4704V121.773Z"
          fill="#D3E8F4"
        />
        <path
          d="M84.8149 139.882H59.0017V142.735H84.8149V139.882Z"
          fill="#D3E8F4"
        />
        <path
          d="M117.438 121.773H97.9594V124.626H117.438V121.773Z"
          fill="#E6EBED"
        />
        <path
          d="M128.272 130.786H97.9594V133.639H128.272V130.786Z"
          fill="#E6EBED"
        />
        <path
          d="M120.696 139.882H97.9594V142.735H120.696V139.882Z"
          fill="#E6EBED"
        />
        <path
          d="M132.889 99.7466H55.6184V103.516H132.889V99.7466Z"
          fill="#D3E8F4"
        />
        <path
          d="M132.889 93.2925H55.6184V97.062H132.889V93.2925Z"
          fill="#D3E8F4"
        />
        <path
          d="M132.889 85.9995H55.6184V89.769H132.889V85.9995Z"
          fill="#D3E8F4"
        />
        <path
          d="M103.628 106.201H55.6184V109.971H103.628V106.201Z"
          fill="#D3E8F4"
        />
        <path
          d="M132.889 176.375H55.6184V180.145H132.889V176.375Z"
          fill="#D3E8F4"
        />
        <path
          d="M132.889 169.924H55.6184V173.693H132.889V169.924Z"
          fill="#D3E8F4"
        />
        <path
          d="M132.889 155.249H55.6184V159.018H132.889V155.249Z"
          fill="#D3E8F4"
        />
        <path
          d="M132.889 162.633H55.6184V166.402H132.889V162.633Z"
          fill="#D3E8F4"
        />
        <path
          d="M74.8506 182.83H55.6184V186.6H74.8506V182.83Z"
          fill="#D3E8F4"
        />
      </g>
      <g filter="url(#filter1_d_807_2058)">
        <path
          d="M190.834 43.9062L96.1539 54.0641C94.5218 54.2392 93.341 55.7032 93.5165 57.3342L107.164 184.149C107.339 185.78 108.805 186.96 110.437 186.785L205.117 176.627C206.749 176.452 207.93 174.988 207.754 173.357L194.107 46.5422C193.932 44.9113 192.466 43.7311 190.834 43.9062Z"
          fill="white"
        />
        <path
          d="M182.604 60.0255L109.375 67.8823C108.382 67.9888 107.663 68.8797 107.77 69.8722L111.031 100.176C111.138 101.168 112.03 101.886 113.023 101.78L186.252 93.9228C187.245 93.8163 187.964 92.9253 187.857 91.9329L184.596 61.6295C184.489 60.6371 183.597 59.919 182.604 60.0255Z"
          fill="#D3E8F4"
        />
        <path
          d="M164.059 69.8691L129.495 73.5774C128.775 73.6547 128.254 74.3004 128.331 75.0198L130.171 92.1159C130.249 92.8353 130.895 93.3558 131.615 93.2786L166.179 89.5702C166.899 89.493 167.42 88.8472 167.342 88.1279L165.503 71.0318C165.425 70.3124 164.779 69.7918 164.059 69.8691Z"
          fill="#D3E8F4"
          stroke="white"
          stroke-width="2.0188"
          stroke-miterlimit="10"
        />
        <path
          d="M132.688 91.0247L164.745 87.5852C165.175 87.539 165.335 87.0001 165.001 86.7272L153.701 77.4725C153.19 77.0532 152.433 77.1345 152.023 77.6525L146.126 85.0864C145.785 85.5144 145.195 85.6559 144.696 85.4225L140.59 83.4974C140.154 83.2919 139.637 83.3736 139.28 83.7031L132.302 90.1877C131.958 90.5073 132.219 91.075 132.684 91.0252L132.688 91.0247Z"
          fill="white"
        />
        <path
          d="M134.952 78.385C135.836 78.2902 136.475 77.4974 136.38 76.6143C136.285 75.7312 135.492 75.0922 134.608 75.187C133.724 75.2818 133.085 76.0746 133.18 76.9577C133.275 77.8408 134.069 78.4798 134.952 78.385Z"
          fill="white"
        />
        <path
          d="M190.827 135.521L117.391 143.4C116.455 143.5 115.777 144.34 115.878 145.276L118.408 168.787C118.509 169.722 119.349 170.399 120.285 170.299L193.721 162.42C194.658 162.319 195.335 161.479 195.234 160.544L192.704 137.033C192.603 136.097 191.763 135.42 190.827 135.521Z"
          fill="white"
          stroke="#D3E8F4"
          stroke-width="1.96"
          stroke-miterlimit="10"
        />
        <path
          d="M154.138 139.46L157.03 166.355"
          stroke="#D3E8F4"
          stroke-width="1.96"
          stroke-miterlimit="10"
        />
        <path
          d="M116.661 152.537L193.49 144.289"
          stroke="#D3E8F4"
          stroke-width="1.96"
          stroke-miterlimit="10"
        />
        <path
          d="M117.63 161.533L194.46 153.285"
          stroke="#D3E8F4"
          stroke-width="1.96"
          stroke-miterlimit="10"
        />
        <path
          d="M149.756 152.127L120.359 155.282L120.664 158.12L150.061 154.965L149.756 152.127Z"
          fill="#D3E8F4"
          stroke="#D3E8F4"
          stroke-width="0.8526"
          stroke-miterlimit="10"
        />
        <path
          d="M139.198 144.144L119.391 146.269L119.697 149.107L139.503 146.982L139.198 144.144Z"
          fill="#D3E8F4"
          stroke="#D3E8F4"
          stroke-width="0.8526"
          stroke-miterlimit="10"
        />
        <path
          d="M136.13 162.687L121.324 164.276L121.629 167.113L136.435 165.525L136.13 162.687Z"
          fill="#D3E8F4"
          stroke="#D3E8F4"
          stroke-width="0.8526"
          stroke-miterlimit="10"
        />
        <path
          d="M186.49 139.067L158.12 142.112L158.426 144.95L186.796 141.905L186.49 139.067Z"
          fill="#D3E8F4"
          stroke="#D3E8F4"
          stroke-width="0.8526"
          stroke-miterlimit="10"
        />
        <path
          d="M175.739 149.285L159.085 151.072L159.391 153.909L176.044 152.122L175.739 149.285Z"
          fill="#D3E8F4"
          stroke="#D3E8F4"
          stroke-width="0.8526"
          stroke-miterlimit="10"
        />
        <path
          d="M178.071 158.185L160.057 160.118L160.362 162.956L178.377 161.023L178.071 158.185Z"
          fill="#D3E8F4"
          stroke="#D3E8F4"
          stroke-width="0.8526"
          stroke-miterlimit="10"
        />
        <path
          d="M190.476 116.281L113.648 124.527L114.051 128.277L190.879 120.031L190.476 116.281Z"
          fill="#D3E8F4"
        />
        <path
          d="M189.787 109.864L112.959 118.11L113.362 121.861L190.19 113.615L189.787 109.864Z"
          fill="#D3E8F4"
        />
        <path
          d="M189.006 102.617L112.178 110.863L112.581 114.613L189.409 106.367L189.006 102.617Z"
          fill="#D3E8F4"
        />
        <path
          d="M162.071 125.823L114.337 130.946L114.74 134.696L162.474 129.573L162.071 125.823Z"
          fill="#D3E8F4"
        />
      </g>
    </g>
    <path
      d="M118.641 218.616L118.641 220.291L120.316 220.291L120.317 218.616L118.641 218.616Z"
      fill="#99B0B7"
    />
    <path
      d="M114.774 222.489L114.774 224.163L116.45 224.163L116.45 222.488L114.774 222.489Z"
      fill="#99B0B7"
    />
    <path
      d="M114.791 214.751L114.79 216.425L116.466 216.425L116.466 214.75L114.791 214.751Z"
      fill="#99B0B7"
    />
    <path
      d="M110.917 218.628L110.916 220.302L112.592 220.302L112.593 218.627L110.917 218.628Z"
      fill="#99B0B7"
    />
    <path
      d="M73.4569 50.1191L72.2788 51.2961L74.2072 53.2229L75.3853 52.0458L73.4569 50.1191Z"
      fill="#99B0B7"
    />
    <path
      d="M78.1803 54.8386L77.0022 56.0156L78.9306 57.9424L80.1087 56.7653L78.1803 54.8386Z"
      fill="#99B0B7"
    />
    <path
      d="M78.9274 50.1155L76.9978 52.0435L78.1752 53.2198L80.1047 51.2919L78.9274 50.1155Z"
      fill="#99B0B7"
    />
    <path
      d="M74.1991 54.8396L72.2695 56.7676L73.4469 57.9439L75.3765 56.016L74.1991 54.8396Z"
      fill="#99B0B7"
    />
    <path
      d="M56.6775 51.6215L56.677 53.2959L58.3529 53.2954L58.3534 51.621L56.6775 51.6215Z"
      fill="#99B0B7"
    />
    <path
      d="M52.8292 55.494L52.8284 57.1685L54.5042 57.1682L54.505 55.4938L52.8292 55.494Z"
      fill="#99B0B7"
    />
    <path
      d="M52.8428 47.758L52.842 49.4324L54.5179 49.4322L54.5187 47.7577L52.8428 47.758Z"
      fill="#99B0B7"
    />
    <path
      d="M48.9737 51.6327L48.9729 53.3071L50.6488 53.3069L50.6496 51.6325L48.9737 51.6327Z"
      fill="#99B0B7"
    />
    <path
      d="M56.2735 53.8825L55.0881 55.0669L56.2728 56.2505L57.4581 55.0662L56.2735 53.8825Z"
      fill="#99B0B7"
    />
    <path
      d="M50.8179 53.8984L49.6326 55.0828L50.8172 56.2664L52.0026 55.082L50.8179 53.8984Z"
      fill="#99B0B7"
    />
    <path
      d="M56.2872 48.4338L55.1018 49.6182L56.2865 50.8018L57.4718 49.6174L56.2872 48.4338Z"
      fill="#99B0B7"
    />
    <path
      d="M50.8223 48.436L49.637 49.6204L50.8216 50.804L52.007 49.6196L50.8223 48.436Z"
      fill="#99B0B7"
    />
    <path
      d="M50.0816 30.8107L50.0811 32.4743L52.7749 32.4735L50.8724 34.3743L52.0498 35.5507L53.9523 33.6498L53.9515 36.3413L55.6165 36.3408L55.6173 33.6493L57.5187 35.549L58.6967 34.372L56.7954 32.4723L59.4892 32.4714L59.4897 30.8078L56.7959 30.8086L58.6984 28.9078L57.521 27.7314L55.6185 29.6323L55.6193 26.9408L53.9543 26.9413L53.9535 29.6328L52.0521 27.7331L50.8741 28.9101L52.7754 30.8099L50.0816 30.8107ZM52.8025 30.8234L53.9603 29.6666L55.5982 29.6661L56.7553 30.8222L56.7548 32.4587L55.597 33.6155L53.9591 33.616L52.802 32.4599L52.8025 30.8234Z"
      fill="#99B0B7"
    />
    <path
      d="M177.866 200.058L176.68 201.242L177.865 202.426L179.05 201.242L177.866 200.058Z"
      fill="#99B0B7"
    />
    <path
      d="M172.401 200.065L171.216 201.249L172.4 202.433L173.586 201.249L172.401 200.065Z"
      fill="#99B0B7"
    />
    <path
      d="M177.87 194.6L176.685 195.785L177.87 196.968L179.055 195.784L177.87 194.6Z"
      fill="#99B0B7"
    />
    <path
      d="M172.406 194.603L171.22 195.787L172.405 196.97L173.59 195.786L172.406 194.603Z"
      fill="#99B0B7"
    />
    <path
      d="M162.814 186.652L162.813 189.378L164.479 189.377L164.479 186.652L162.814 186.652Z"
      fill="#99B0B7"
    />
    <path
      d="M162.805 193.34L162.804 196.065L164.469 196.065L164.47 193.339L162.805 193.34Z"
      fill="#99B0B7"
    />
    <path
      d="M165.638 190.526L165.637 192.19L168.365 192.19L168.366 190.526L165.638 190.526Z"
      fill="#99B0B7"
    />
    <path
      d="M158.947 190.524L158.946 192.188L161.674 192.187L161.675 190.523L158.947 190.524Z"
      fill="#99B0B7"
    />
    <defs>
      <filter
        id="filter0_d_807_2058"
        x="19.2694"
        y="47.3321"
        width="148.22"
        height="180.517"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="11.76" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_807_2058"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_807_2058"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_807_2058"
        x="69.9793"
        y="20.3689"
        width="161.312"
        height="189.954"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="11.76" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_807_2058"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_807_2058"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_807_2058">
        <rect
          width="196"
          height="186.753"
          fill="white"
          transform="translate(27 33.2148)"
        />
      </clipPath>
    </defs>
  </>,
  {
    viewBox: '25 0 200 211',
    fill: 'none',
  },
);

DocumentsWithStars.displayName = 'DocumentsWithStars';

export default DocumentsWithStars;
